import React from 'react';

import { useLocation } from 'react-router-dom';

import { useNavLinks } from '@/hooks/useNavLinks';
import { useSettings } from '@/hooks/useSettings.hook';

import { RoutesEnum } from '@/enums/routes.enum';

import * as S from './PageNavigation.styles';

const PageNavigation: React.FC = () => {
  const { isMobile } = useSettings();
  const { navLinks } = useNavLinks();
  const { pathname } = useLocation();

  return isMobile ? (
    <>
      {pathname === RoutesEnum.help ? null : (
        <S.MobileNavWrapper>
          {navLinks.map((link) => (
            <S.MobileStyledLink
              key={link.linkData.to as RoutesEnum}
              selected={link.selected}
              to={link.linkData.to}
            >
              {link.label}
            </S.MobileStyledLink>
          ))}
        </S.MobileNavWrapper>
      )}
    </>
  ) : (
    <S.NavWrapper>
      {navLinks.map((link) => (
        <S.StyledLink
          key={link.linkData.to as RoutesEnum}
          selected={link.selected}
          to={link.linkData.to}
        >
          {link.label}
        </S.StyledLink>
      ))}
    </S.NavWrapper>
  );
};

export default PageNavigation;
